// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"EZuloBsZwgC6","localeFlag":"-9bqnuaUK8IN"};